// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__stepWrap--J1qPC {\n  margin-top: 0;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/InvitedProviderOnboarding/CreateProfile/s.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF","sourcesContent":[".stepWrap {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepWrap": "s-module__stepWrap--J1qPC"
};
export default ___CSS_LOADER_EXPORT___;
